import { render, staticRenderFns } from "./NLPModel.vue?vue&type=template&id=58878a0e&"
import script from "./NLPModel.vue?vue&type=script&lang=js&"
export * from "./NLPModel.vue?vue&type=script&lang=js&"
import style0 from "./NLPModel.vue?vue&type=style&index=0&id=58878a0e&prod&scope=true&lang=css&"
import style1 from "./NLPModel.vue?vue&type=style&index=1&id=58878a0e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports